import { CARD_TYPES } from 'src/features/cards/types';
import { ALLOWED_DAYS } from 'src/features/memberships/types';
import subscriptionMessages from 'src/features/subscriptions/utils/messages.ts';

type PrepaidCard = {
    id: string;
    card_number: string;
    card_type: CARD_TYPES;
    owner_name: string;
    valid_from: string;
    valid_until: string;
    allowed_hours_start: string;
    allowed_hours_end: string;
    allowed_parkings: string[];
    allowed_points: string[];
    allowed_days: ALLOWED_DAYS[];
    allowed_parking_spaces: number;
    prepaid_group_id: string;
    group_members: string[];
    reserve_place: boolean;
    purchase_plan_id: string;
};

enum DURATION {
    DAY = 'DAY',
    WEEK = 'WEEK',
    MONTH = 'MONTH',
    YEAR = 'YEAR',
}

const DURATION_MAP = {
    [DURATION.DAY]: {
        type: subscriptionMessages.subscriptionDaily,
        count: subscriptionMessages.subscriptionDays,
    },
    [DURATION.WEEK]: {
        type: subscriptionMessages.subscriptionWeekly,
        count: subscriptionMessages.subscriptionWeeks,
    },
    [DURATION.MONTH]: {
        type: subscriptionMessages.subscriptionMonthly,
        count: subscriptionMessages.subscriptionMonths,
    },
    [DURATION.YEAR]: {
        type: subscriptionMessages.subscriptionYearly,
        count: subscriptionMessages.subscriptionYears,
    },
};

enum LANGUAGE {
    BG = 'BG',
    EN = 'EN',
}

const LANGUAGE_MAP = {
    [LANGUAGE.BG]: subscriptionMessages.bulgarian,
    [LANGUAGE.EN]: subscriptionMessages.english,
};

type PrepaidPlan = {
    id: string;
    plan_name: string;
    languages: LANGUAGE[];
    description: string;
    duration: {
        unit: DURATION;
        value: number;
    };
    allowedWeekDays: ALLOWED_DAYS[];
    allowedHours: {
        fromHour: string;
        toHour: string;
    };
    dueAmount: number;
    dueTaxPercent: number;
    dueTaxAmount: number;
    dueAmountWithTax: number;
    endAtMidnight: boolean;
};
export { DURATION, DURATION_MAP, LANGUAGE_MAP, LANGUAGE };
export type { PrepaidCard, PrepaidPlan };
